import { PageHolder, PageContent } from "./Scoodle2FADefaultPage.Styled";

export const Scoodle2FADefaultPage: React.FC = (props) => {
	return (
		<PageHolder>
			<PageContent>{props.children}</PageContent>
		</PageHolder>
	);
};
